import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import SubHeader from "../../layouts/subheader/SubHeader";
import { Client, getAllClientsList } from "../../apis/tenantApi/tenantApi";
import { Container, CircularProgress } from '@mui/material';
import TenantList from "../../components/Tenants/TenantList";
import { checkRolePermissions } from "../../utils/HasPermission";

const AllTenants = () => {
  const [tenants, setTenants] = useState<Client[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const isCreateEnabled = checkRolePermissions("Tenants", true, "create")

  const menuItems = [
    {
      label: "Create Client",
      onClick: () => {
        navigate("create");
      },
      disabled : !isCreateEnabled
    },
    
  ];

  useEffect(() => {
    const fetchTenants = async () => {
      try {
        const fetchedTenants = await getAllClientsList();
        if (Array.isArray(fetchedTenants)) {
          console.log(fetchedTenants)
          setTenants(fetchedTenants);
        } else {
          console.error("Unexpected response format:", fetchedTenants);
          setTenants([]);
        }
      } catch (error) {
        console.error("Error fetching tenants:", error);
        setTenants([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchTenants();
  }, []);

  return (
<div className="tab-page-layout-1">
  <SubHeader title="All Tenants" menuItems={menuItems} />
  {isLoading ? (
    <Container maxWidth="sm" sx={{ textAlign: 'center', marginTop: '100px' }}>
      <CircularProgress />
      <div>Loading data...</div>
    </Container>
  ) : (
    <>
    <TenantList tenants={tenants} />
    </>
  )}
</div>
  );
};

export default AllTenants;